<div class="getstarted">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <div class="sectpad container-fluid">
        <!-- <a class="navbar-brand logomain getlogo" href="javascript:void(0)"><img src="assets/images/logoheadwhite.png"
            height="71" class="logo" routerLink="/"><img src="assets/images/logotxtwhite.png" height="71" class="logo"
            routerLink="/"><img src="assets/images/hglogo-mbl.png" width="150" class="logo1" routerLink="/"></a> -->
        <a class="navbar-brand logomain getlogo" href="javascript:void(0)" routerLink="/">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569492224/Static%20images/Logo/honest-gorilla-white_skefuq.svg" alt="White Honest Gorilla combo logo with Eva face" title="White Honest Gorilla combo logo with Eva face" height="60" class="logo logohead drag-drop" alt="Honest Gorilla">
          <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569492320/Static%20images/Logo/logotxt-white_oi6rrh.svg" alt="Honest Gorilla logo in white" title="White Honest Gorilla logo" class="logo1 mt-2"></a>
        <button (click)="addClass($event)" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
          aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
          <img src="assets/images/list-mbl.png" width="18" id="menuIcon" class="listicn">
        </button>
        <div class="collapse navbar-collapse" id="navbarsExampleDefault">
          <ul class="navbar-nav ml-auto webnav">
            <!-- <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" routerLink="/about">ABOUT</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" routerLink="/commercial">COMMERCIAL</a>
            </li>
            <li class="nav-item"> 
              <a class="nav-link" href="javascript:void(0)" (click) = "faqus()" routerLink="/faq">FAQ</a>   
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" routerLink="/blog">BLOG</a>
            </li>
            <li class="nav-item"> 
              <a class="nav-link" href="javascript:void(0)" routerLink="/giveback">GIVEBACK</a>   
            </li>
            
            <li class="nav-item">
              <a class="nav-link"  href="javascript:void(0)" (click) = "fcontactus()" routerLink="/faq/contact-us">CONTACT US</a>
            </li>
  
            <li class="nav-item"  *ngIf="!showLogin ">
              <a class="nav-link"  href="javascript:void(0)" (click)="gotoProfile()" >PROFILE</a>
            </li>
            
          </ul>
          <div class="mobilenav comabtmbl" *ngIf="!showLogin">
            <!-- <div class="col-12 row m-0">
                <div class="col-6 col-md mt-4 mb-2  pl-0">
                    <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
                </div>
                <div class="col-6 col-md mt-4 mb-2 pr-0">
                    <a href="javascript:void(0)" class="btnsec w-100 font14" routerLink="/getstarted">SHOP NOW</a>
                </div>
            </div> -->
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/">Commercial</h5>
                </div>
  
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/faq/contact-us">Contact us</h5>
                </div>
              
  
               
                
            </div>
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
                </div>
                <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                    
                    <h5 class="font16 semi-bold"  (click) = "gotoProfile()">Profile</h5> 
               </div>
  
               
               
            </div>
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
                </div>
  
                <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                    
                    <h5 class="font16 semi-bold" (click) = 'logout()' routerLink="/">Logout</h5> 
               </div>
               <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                   
                   <h5 class="font16 semi-bold"  routerLink="/login">Login</h5> 
              </div>
               <div class="col-6 col-md mb-2 pt-1 mt-2">
                 
                <h5 class="font16 semi-bold" routerLink="/giveback" >Giveback</h5>
            </div>
  
            <!-- <div class="col-6 col-md mb-2 mt-2 p-0">
                <a href="javascript:void(0)" class="btnsec font14" routerLink="/get-started">SHOP NOW</a>
            </div> -->
              
            </div>
  
  
            <div class="col-12 row m-0 p-0">
  
              
            </div>
  
            
  
            <!-- <div class="col-12 row m-0 p-0">
                <div class="col-4 col-md mb-2 mt-2 p-0">                      
                    <a class="btn btn-yw-primary mr-2 ml-2" routerLink="/get-started" >SHOP NOW</a>
                </div>
            </div> -->
  
        </div>
  
        <div class="mobilenav comabtmbl" *ngIf="showLogin">
            <!-- <div class="col-12 row m-0">
                <div class="col-6 col-md mt-4 mb-2  pl-0">
                    <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
                </div>
                <div class="col-6 col-md mt-4 mb-2 pr-0">
                    <a href="javascript:void(0)" class="btnsec w-100 font14" routerLink="/getstarted">SHOP NOW</a>
                </div>
            </div> -->
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/">Commercial</h5>
                </div>
                <div class="col-6 col-md mb-2 mt-2">
                    <!-- <h5 class="font18" routerLink="/about">About</h5>
                    <a class="nav-link aboutshop p-0 font16 abtmbl semi-bold" href="#shopSection" (click)="mobhead($event)">About</a> -->
                    <h5 class="font16 semi-bold" routerLink="/giveback" >Giveback</h5>
                </div>
  
               
                
            </div>
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
                </div>
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/faq/contact-us">Contact us</h5>
                </div>
               
               
            </div>
            <div class="col-12 row m-0 p-0">
                <div class="col-6 col-md mb-2 mt-2">
                    <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
                </div>
  
                <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                    
                    <h5 class="font16 semi-bold"  (click) = "gotoProfile()">Profile</h5> 
               </div>
  
               <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                   
                <h5 class="font16 semi-bold"  routerLink="/login">Login</h5> 
           </div>
  
              
            </div>
  
            <div class="col-12 row m-0 p-0" *ngIf="!showLogin">
  
                <div class="col-6 col-md mb-2 mt-2"  >
                   
                    <h5 class="font16 semi-bold"  ></h5> 
               </div>
  
                <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                    
                    <h5 class="font16 semi-bold" (click) = 'logout()' routerLink="/">Logout</h5> 
               </div>
               <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                   
                   <h5 class="font16 semi-bold"  routerLink="/login">Login</h5> 
              </div>
                  
            </div>
  
            <!-- <div class="col-12 row m-0 p-0">
                <div class="col-4 col-md mb-2 mt-2 p-0">                      
                    <a class="btn btn-yw-primary mr-2 ml-2" routerLink="/get-started" >SHOP NOW</a>
                </div>
            </div> -->
  
        </div>
        </div>
        <!-- <a class="btn btn-pwhite-primary mr-2 ml-2 login mobileview" *ngIf="showLogin" routerLink="/residentialQues">GET STARTED</a> -->
        <a class="btn btn-pwhite-primary mr-2 ml-2 login webview" *ngIf="showLogin" routerLink="/login">LOGIN</a>
        <a class="btn btn-pwhite-primary mr-2 ml-2 login" *ngIf="!showLogin" href="javascript:void(0)" (click) = 'logout()' routerLink="/">LOGOUT</a>
        <a class="btn btn-wpink-primary getstart" (click)="getQuestionnaire()">GET STARTED</a>
      </div>
    </nav>
  </div>